import React from 'react'
// eslint-disable-next-line import/no-extraneous-dependencies
import { TextLink } from 'baby-design'
import { ChatProps } from './Chat.types'
import css from './Chat.styles.scss'

const Chat: React.FC<ChatProps> = ({ onChat }) => (
  <div className={css.Chat}>
    More questions?{' '}
    <TextLink underline weight="medium" onClick={() => onChat?.()}>
      Chat with Babylist support
    </TextLink>
  </div>
)
export default Chat
